import { useEffect, useRef, useState } from "react";
import codeService from "../../../../Services/code.service";
import { ProgrammingLanguage, Question } from "../../../../Interface/Index";
import CodeEditor from "../../../../Components/CodeEditor/CodeEditor";
import { Flex, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import "./coding.scss";

interface CodingRoundProps {
  onChange: (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    value: string | null
  ) => void;
  question: Question;
}
const CodingRound: React.FC<CodingRoundProps> = ({ onChange, question }) => {
  const [compiling, setCompiling] = useState({
    loading: false,
    message: "",
  });
  const [languages, setLanguages] = useState<ProgrammingLanguage[]>([]);
  const cardRef = useRef<HTMLDivElement>(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        setCompiling({ loading: true, message: "Loading editor..." });
        await getLanguages();
      } catch (error: any) {
        console.log("🚀 ~ init code editor ~ error:", error);
      } finally {
        setCompiling({ loading: false, message: "" });
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (question) {
      const event = {
        target: { value: "" },
      } as React.ChangeEvent<HTMLTextAreaElement>;
      onChange(event, null);
    }
  }, [question]);

  const handleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  const getLanguages = async () => {
    const languageResponse = await codeService.getAllLangugaes();
    setLanguages(languageResponse);
  };

  return (
    <section>
      <div style={{ width: "100%", height: "100%", position: "relative" }}>
        {compiling.loading && (
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              zIndex: 300,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
            }}
          >
            <Flex align="center" gap="middle">
              <Spin
                spinning={compiling.loading}
                indicator={<LoadingOutlined spin />}
                size="large"
                tip={compiling.message ? compiling.message : "Please wait..."}
                className="spinner"
                fullscreen
              />
            </Flex>
          </div>
        )}

        <div className="coding_round">
          <Flex gap="middle" style={{ width: "100%", height: "100%" }}>
            <div
              style={{
                width: "100%",
                ...(isFullScreen && {
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  zIndex: 30,
                  background: "#fff",
                }),
              }}
              ref={cardRef}
              className="editor_container"
            >
              <CodeEditor
                handleFullScreen={handleFullScreen}
                languages={languages}
                setCompiling={setCompiling}
                isFullScreen={isFullScreen}
                onChange={onChange}
                question={question}
              />
            </div>
          </Flex>
        </div>
      </div>
    </section>
  );
};

export default CodingRound;
